export const APPLE_PAY_SCRIPT_ID = 'apple-pay-script'
